import { Component, OnInit, Input, ChangeDetectorRef } from "@angular/core";
import { ChatRowComponent } from "./chat-row/chat-row.component";
import { Chat } from "../../../@core/data/chat";
import { ChatService } from "../../../@core/api/chat.service";
import { NbWindowService, NbWindowState } from "@nebular/theme";
import { LenguageService } from "../../../@core/utils/lenguage.service";
import { Router } from "@angular/router";

@Component({
  selector: "ngx-chats-table",
  templateUrl: "./chat-table.component.html",
  styleUrls: ["./chat-table.component.scss"],
})
export class ChatsTableComponent implements OnInit {
  filters: any;
  @Input() type: string;
  @Input() assigned: boolean = false;
  chats: Chat[];
  lastPage: boolean;
  loading: boolean;
  pageNumberShow: number = 1;
  pagination = {
    perPage: 100,
    pageNumber: 0,
  };
  order = {
    field: "timestamp",
    direction: "desc",
  };
  range: any;
  selectedRowId: string = "";
  addFilter: boolean = false;
  dateRange: {
    dateStart: number;
    dateEnd: number;
  };

  constructor(
    private windowService: NbWindowService,
    private router: Router,
    private chatService: ChatService,
    public language: LenguageService
  ) {}

  async ngOnInit() {
    this.getChats();
  }

  nextPage() {
    if (!this.lastPage && !this.loading) {
      this.pagination.pageNumber++;
      this.getChats();
      this.pageNumberShow++;
    }
  }

  prevPage() {
    if (this.pagination.pageNumber > 0 && !this.loading) {
      this.pagination.pageNumber--;
      this.getChats();
      this.pageNumberShow--;
    }
  }

  selectRow(data) {
    console.log(data);
    if (data.select) {
      this.selectedRowId = data.id;
    } else {
      this.selectedRowId = "";
    }
    /* 
        let leads = this.leads;
        this.leads = [];
        this.leads = leads;
    */
  }

  async getChats() {
    this.loading = true;
    this.chats = <Chat[]>(
      await this.chatService.getChats(
        this.pagination,
        this.filters,
        this.order
      )
    );

    this.chats.map((f) => {
      if ( f.notAllowed) {
        f.notAllowed = Object.keys(f.notAllowed).map((k) => {
          return {
            id: k,
            values: f.notAllowed[k].values,
            title: f.notAllowed[k].title,
          };
        });
      }
     
    });

    console.log(this.chats)

    this.loading = false;

    if (this.chats.length < this.pagination.perPage) {
      this.lastPage = true;
    } else {
      this.lastPage = false;
    }
  }

  async createChat() {
    this.loading = true;
    this.loading = false;
    this.router.navigate(["home", "chat"]);
  }

  rangeChanged() {
    let dateEnd = new Date(this.range.end).getTime() + 24 * 60 * 60 * 1000;
    let dateStart = (new Date(this.range.start).getTime() * 1000) / 1000;
    this.filters.dateRange = { dateStart, dateEnd };
  }

  async removeFilters() {
    this.dateRange = undefined;
    this.filters = undefined;
    this.addFilter = false;
    await this.getChats();
  }
}
